
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"
import { Loading } from '../../../../../Helper/Loading'
import { useAuthState } from '../../../../../Helper/Context'
import PillerWiseBenchMarkModal from './Modal/PillerWiseBenchMarkModal'
import { FinancialYearDataDDL } from '../../../../../Components/CommonDDL/FinancialYearDataDDL'
import { MonthDataDDL } from '../../../../../Components/CommonDDL/MonthDataDDL'
import { WardNameDataDDL } from '../../../../../Components/CommonDDL/WardNameDataDDL'
import { Pegination } from '../../../../../Components/Pegination/Pegination'
import * as XLSX from 'xlsx';
import { toastErrorr, toastInfo, toastSuccesss } from '../../../../../Helper/ToastMessage'
import { BaseUrl } from '../../../../../Helper/BaseUrl'


export const PillerWiseUploadBenchMark = (props) => {

    const {
        setUploadData,
        WardName,
        setWardName,
        FinancialYear,
        setFinancialYear,
        VendorName,
        Month,
        setMonth
    } = props

    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")


    // ----------pagination-------------

    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const fileInputRef = useRef(null);

    const [loader, setloader] = useState(false)
    const [File, setFile] = useState(null)
    const [Keys, setKeys] = useState();
    const [data, setData] = useState([]);
    const [IsVerify, setIsVerify] = useState(true)
    const [IsValidate, setIsValidate] = useState(true)
    const [IsFinalUpload, setIsFinalUpload] = useState(true)
    const [ShowAction, setShowAction] = useState(false)
    const [IsShowShalarthXLSX, setIsShowShalarthXLSX] = useState(false)
    const [invalidRows, setinvalidRows] = useState([])
    const [IsFinalVerify, setIsFinalVerify] = useState(false)

    // const [WardName, setWardName] = useState({
    //     DDL: [],
    //     ID: '0',
    //     Label: "Select...",
    // })

    // const [FinancialYear, setFinancialYear] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",
    // })
    // const [Month, setMonth] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",

    // })

    const [DesignationPopupShow, setDesignationPopupShow] = useState()


    const handleEditOnClick = (item) => {
        setrowData(item)
        setDesignationPopupShow(true)
        setapiFlag('Update')
    }

    const handleOnCloseClick = () => {
        setDesignationPopupShow(false)
        handleIsPost()
    }

    const handleClear = () => {
        setFile(null)
        setData([])
        if (fileInputRef.current) {
            fileInputRef.current.value = ""; // 👈 clears file input
        }
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...',
        })
        setFinancialYear({
            ...FinancialYear,
            ID: 0,
            Label: 'Select...',
        })
        setMonth({
            ...Month,
            ID: 0,
            Label: 'Select...',
        })
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }


    const headers = [
        "sr_No",
        "m_FinancialYearID",
        "m_MonthID",
        "m_WardID",
        "m_eleC_PillerID",
        "pillerNo",
        "pillerBenchMark",
        "max",
        "min"
    ]

    const handleFileUpload = (e) => {
        setShowAction(false)
        // setFile(e.target.files[0])
        setIsVerify(false)
        setIsValidate(true)
        setIsShowShalarthXLSX(false)
        setIsFinalUpload(true)
        setinvalidRows([])
        // const file = e.target.files[0];
        if (!File) return;

        const reader = new FileReader();
        reader.onload = (evt) => {
            const bstr = evt.target.result;
            const workbook = XLSX.read(bstr, { type: 'binary' });

            // Assuming first sheet
            const worksheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[worksheetName];

            // Convert to JSON
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }); // header:1 gives array of arrays
            setKeys(jsonData[0])
            const remainingData = jsonData.slice(1);

            const result = remainingData.map(row => {
                return headers && headers.length > 0 && headers.reduce((obj, key, index) => {
                    obj[key] = row[index];
                    return obj;
                }, {});
            });
            console.log('result', result)
            setData(result);
        };
        reader.readAsBinaryString(File);

    }

    const handleVerifySheet = () => {
        setShowAction(false)
        if (File == "") {
            toastErrorr('Please select a file first')
        } else {
            setIsVerify(false)
            const formdata = new FormData();
            formdata.append("File", File);

            const requestOptions = {
                method: "POST",
                body: formdata,
                redirect: "follow"
            };
            setloader(true)

            fetch(`${BaseUrl}/UploadExcelData/T_ELE_Excel_CurrentRatingData_Verify`, requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    setloader(false)
                    if (result.statusCode >= 200 && result.statusCode <= 300) {
                        toastSuccesss("Excel verified successfully")
                        setIsVerify(true)
                        setIsValidate(false)
                        setIsShowShalarthXLSX(false)
                        setinvalidRows([])
                    } else {
                        toastErrorr(result?.message)
                        if (result) {
                            invalidRows.push(result?.message)
                        }
                    }
                })
                .catch((error) => {
                    setloader(false)
                    // toastError("Something went wrong")
                });
        }
    }

    const handleUploadValidate = () => {
        setShowAction(false)
        if (File == "") {
            toastErrorr('Please select a file first')
        } else {
            const formdata = new FormData();
            formdata.append("File", File);
            formdata.append("M_UserID", UserID);

            const requestOptions = {
                method: "POST",
                body: formdata,
                redirect: "follow"
            };
            setloader(true)
            fetch(`${BaseUrl}/UploadExcelData/T_ELE_Excel_CurrentRatingData_PillerNo_Validate`, requestOptions)
                .then((response) => {
                    if (response?.status >= 200 && response.status <= 300) {
                        return response.json()
                    } else {
                        toastErrorr('An error has occurred.')
                    }
                })
                .then((result) => {
                    if (result?.statusCode == 400) {
                        setloader(false)
                        toastInfo("Please add a valid pillar benchmark")
                    } else {
                        setloader(false)
                        toastSuccesss(result?.message)
                        handleGetData()
                        setIsFinalUpload(false)
                        setIsValidate(true)
                        setIsShowShalarthXLSX(false)
                        setinvalidRows(result?.invalidRecords[0]?.errors)
                    }

                })
                .catch((error) => {
                    setloader(false)
                    // toastErrorr("Something went wrong")
                });
        }
    }

    const handleGetData = () => {
        setShowAction(false)
        const requestOptions = {
            method: "GET",
            redirect: "follow"
        };
        setloader(true)
        fetch(`${BaseUrl}/Electrical/Get_T_ELE_Excel_CurrentRating_Tempdata_Validate_Select?M_FinancialYearID=${FinancialYear?.ID}&M_MonthID=${Month?.ID}&M_WardID=${WardName?.ID}&Flag=PillerNo_Validate&M_UserID=${UserID}&FromTop=1&ToTop=9999`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result?.code >= 200 && result?.code <= 300 && result?.status && result?.data) {
                    if (result?.data?.table.length > 0) {
                        setData(result?.data?.table)
                        hasInvalidService(result?.data?.table)
                        setloader(false)
                    } else {
                        setloader(false)
                        setData([])
                        toastInfo('No Data Found')
                    }
                } else {
                    setloader(false)
                    toastErrorr('Something Went Wrong')
                }
            })
            .catch((error) => {
                setloader(false)
                console.error(error)
            });
    }

    const hasInvalidService = (response) => {
        const check = response.some((item) => item.pillerNo_Validation == 0)
        if (check) {
            setIsValidate(false) // Invalide
            setIsShowShalarthXLSX(true)
            setIsFinalUpload(true)

        } else {
            setIsValidate(true) // valide
            setIsShowShalarthXLSX(false)
            setIsFinalUpload(false)
        }
    }

    const handleFinalUpload = () => {
        setShowAction(false)
        if (File == "") {
            toastErrorr('Please select a file first')
        } else {
            const formdata = new FormData();
            formdata.append("File", File);
            formdata.append("M_UserID", UserID);

            const requestOptions = {
                method: "POST",
                body: formdata,
                redirect: "follow"
            };
            setloader(true)
            fetch(`${BaseUrl}/UploadExcelData/ELE_Excel_CurrentRating_Tempdata_Upload`, requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    setloader(false)
                    if (result.success) {
                        setShowAction(true)
                        handleGetFinalUploadData()
                        toastSuccesss("Data Upload Successful")
                        setIsFinalUpload(true)
                        setinvalidRows([])
                    } else {
                        setShowAction(false)
                        toastErrorr(result?.message)
                        if (result?.invalidRows?.length > 0) {
                            setinvalidRows(result?.invalidRows[0]?.errors)
                        }
                    }
                })
                .catch((error) => {
                    setShowAction(false)
                    setloader(false)
                    // toastError("Something went wrong")
                });
        }
    }


    const handleGetFinalUploadData = () => {
        const requestOptions = {
            method: "GET",
            redirect: "follow"
        };
        setloader(true)
        fetch(`${BaseUrl}/Electrical/Get_T_ELE_Excel_CurrentRating_Tempdata_Select?T_ELE_Excel_CurrentRating_TempdataID=0&M_FinancialYearID=${FinancialYear?.ID}&M_MonthID=${Month?.ID}&M_ELEC_WorkID=0&M_WardID=${WardName?.ID}&M_Ward_Wise_VendorID=${VendorName?.ID}&M_ELEC_PillerID=0&M_UserID=${UserID}&From=1&To=9999`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result?.code >= 200 && result?.code <= 300 && result?.status && result?.data) {
                    if (result?.data?.table.length > 0) {
                        setData(result?.data?.table)
                        setIsFinalVerify(true)
                        setloader(false)
                    } else {
                        setloader(false)
                        setData([])
                        toastInfo('No Data Found')
                    }
                } else {
                    setData([])
                    setloader(false)
                    toastErrorr('Something Went Wrong')
                }
            })
            .catch((error) => {
                setData([])
                setloader(false)
                console.error(error)
            });
    }

    return (
        <>
            {/* {isLoading && <Loading />} */}
            {loader && <Loading />}
            <div>

                <div id="" className="content1">
                    <div className="data_mob1">
                        <div >


                            <div className="row m-0 ">
                                <div className="col-12 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                    <div className="col-12">

                                        <div className="row pl-2">

                                            <div className="col-12 col-md-4 col-lg-2">
                                                <label for="" className=""><b>Financial Year</b></label>
                                                <input
                                                    disabled={true}
                                                    className='form-control'
                                                    type='text'
                                                    value={FinancialYear?.Label != "Select..." ? FinancialYear?.Label : ''}
                                                />
                                            </div>

                                            <div className="col-12 col-md-4 col-lg-2">
                                                <label for="" className=""><b>Month</b></label>
                                                <input
                                                    disabled={true}
                                                    className='form-control'
                                                    type='text'
                                                    value={Month?.Label != "Select..." ? Month?.Label : ''}
                                                />
                                            </div>

                                            <div className="col-12 col-md-4 col-lg-2">
                                                <label for="" className=""><b>Ward Name</b></label>
                                                <input
                                                    disabled={true}
                                                    className='form-control'
                                                    type='text'
                                                    value={WardName?.Label != "Select..." ? WardName?.Label : ''}
                                                />
                                            </div>

                                            {
                                                WardName?.ID == 2 &&
                                                <div className="col-12 col-md-4 col-lg-2">
                                                    <label for="" className=""><b>Vendor Name</b></label>
                                                    <input
                                                        disabled={true}
                                                        className='form-control'
                                                        type='text'
                                                        value={VendorName?.Label != "Select..." ? VendorName?.Label : ''}
                                                    />
                                                </div>
                                            }

                                            <div className="col-12 col-md-4 col-lg-2">
                                                <label for="" className=""><b>Upload Excel</b></label>
                                                <input
                                                    className='form-control'
                                                    type='file'
                                                    ref={fileInputRef}
                                                    onChange={(e) => setFile(e.target.files[0])}
                                                />
                                            </div>

                                            <div className="col-12 col-md-3 col-lg-2 mt-4">
                                                {
                                                    !IsFinalVerify &&
                                                    <button
                                                        disabled={FinancialYear?.ID == 0 || Month?.ID == 0 || WardName?.ID == 0}
                                                        type="button"
                                                        className="btn btn-primary"
                                                        style={{ marginTop: '2px' }}
                                                        onClick={(e) => handleFileUpload(e)}
                                                    >
                                                        Upload</button>
                                                }

                                                <button
                                                    type="button"
                                                    className="btn btn-danger mx-1 px-3"
                                                    style={{ marginTop: '2px' }}
                                                    onClick={() => handleClear()}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>

                                        <div className="row mob_table table-responsive pt-1" style={{ height: '50vh' }}>
                                            <table
                                                id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered"

                                            >
                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr.No</th>
                                                        {/* <th>M_FinancialYearID</th>
                                                        <th>M_MonthID</th> */}
                                                        <th>M_WardID</th>
                                                        {/* <th>Ward Name</th> */}
                                                        <th>M_ELEC_PillerID</th>
                                                        <th>PillerNo</th>
                                                        <th style={{ width: '12%' }}>PillerBenchMark</th>
                                                        <th>Max</th>
                                                        <th>Min</th>
                                                        <th>Remark</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        data && data.length > 0 ? data.map((i, j) =>
                                                            <tr style={{ width: '100%' }}>
                                                                <td style={{ textAlign: "center" }}>{j + 1}</td>
                                                                <td style={{ textAlign: "center" }}>{i?.m_WardID}</td>
                                                                {/* <td style={{ textAlign: "center" }}>{i?.wardName}</td> */}
                                                                <td style={{ textAlign: "center" }}>{i?.m_eleC_PillerID}</td>
                                                                <td
                                                                    style={{ textAlign: "center", background: (i?.pillerNo_Validation == "0") && 'red', color: (i?.pillerNo_Validation == "0") && 'white' }}
                                                                >
                                                                    {i?.pillerNo}
                                                                </td>
                                                                <td style={{ textAlign: "right" }}>{i?.pillerBenchMark}</td>
                                                                <td style={{ textAlign: "right" }}>{i?.max}</td>
                                                                <td style={{ textAlign: "right" }}>{i?.min}</td>
                                                                <td>{i?.remark ? i?.remark : ''}</td>
                                                                <td style={{ textAlign: "center", width: '10%' }}>
                                                                    <span>
                                                                        {
                                                                            ShowAction ?
                                                                                <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                    style={{ cursor: 'pointer' }}
                                                                                    onClick={() => handleEditOnClick(i)}
                                                                                >
                                                                                </i>
                                                                                : '-'
                                                                        }
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) :
                                                            <td colSpan={15}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="row mx-0 my-3">
                                            <div className="px-5 border23 d-flex align-items-center justify-content-center col-12">
                                                <button type="button" className="btn btn-primary px-5 mx-3"
                                                    disabled={IsVerify}
                                                    onClick={handleVerifySheet}
                                                >
                                                    Verify
                                                </button>
                                                <button type="button" className="btn btn-primary px-5 mx-3"
                                                    disabled={IsValidate}
                                                    onClick={handleUploadValidate}
                                                >
                                                    Validate Piller No.
                                                </button>
                                                <button type="button" className="btn btn-primary px-5 mx-3"
                                                    disabled={IsFinalUpload}
                                                    onClick={handleFinalUpload}
                                                >
                                                    Final Upload
                                                </button>
                                            </div>
                                        </div>



                                        {/* {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        } */}
                                    </div>
                                </div>
                            </div>




                        </div>
                    </div>
                </div>
            </div>

            {
                DesignationPopupShow ?
                    <PillerWiseBenchMarkModal
                        open={DesignationPopupShow}
                        // popupHeading="Location Name"                         
                        handleIsPost={handleIsPost}
                        handleOnCloseClick={handleOnCloseClick}
                        Flag={apiFlag}
                        rowData={rowData}
                        handleGetData={handleGetFinalUploadData}
                        IsPost={IsPost}
                        setIsPost={setIsPost}
                    />
                    : <></>
            }



        </>
    )
}